import { useQuery } from '@apollo/client';

import {
  GetWishlistByLoggedUserOrOwnerQuery,
  GetWishlistByLoggedUserOrOwnerQueryVariables,
} from '@notino/shared/definitions/types';

import { useWishlistOwnerId } from './hooks/useWishlistOwnerId';
import getWishlistByLoggedUserOrOwnerQuery from './queries/wishlistByLoggedUserOrOwner.graphql';

export const useWishlistForLoggedUserOrOwner = () => {
  const wishlistOwner = useWishlistOwnerId();

  const { data: loggedUserOrOwner, loading } = useQuery<
    GetWishlistByLoggedUserOrOwnerQuery,
    GetWishlistByLoggedUserOrOwnerQueryVariables
  >(getWishlistByLoggedUserOrOwnerQuery, {
    ssr: true,
    variables: {
      owner: wishlistOwner,
    },
    errorPolicy: 'all',
  });
  return {
    productIds: loggedUserOrOwner?.WishlistByLoggedUserOrOwner?.products ?? [],
    loading,
    owner: wishlistOwner,
    userId: loggedUserOrOwner?.user?.id,
  };
};
